'use client'

import { createContext, useContext, useMemo } from 'react'

const RichTextCanvasContext = createContext(false)

export function RichTextCanvasProvider({ children }) {
  const value = useMemo(() => true, [])
  return (
    <RichTextCanvasContext.Provider value={value}>
      {children}
    </RichTextCanvasContext.Provider>
  )
}

export function useInRichTextCanvas() {
  return useContext(RichTextCanvasContext)
}
